<template>
  <article class="faq" :data-open="open">
    <header class="faq-header" @click="handleQuestionClick">
      <ExpandIndicator :open="open" />
      <h3 class="question">{{ q }}</h3>
    </header>
    <div class="answer" ref="answer">
      <slot />
    </div>
  </article>
</template>

<script>
import ExpandIndicator from "@/components/ExpandIndicator.vue";

export default {
  name: "faq",
  components: {
    ExpandIndicator,
  },
  props: ["q"],
  data() {
    return {
      open: false
    }
  },
  methods: {
    showAnswer() {
      this.open = true
      this.$refs.answer.style
    },
    handleQuestionClick() {
      this.open = !this.open

    }
  }
}
</script>

<style lang="scss">
  .faq {
    .faq-header {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      padding: 0.5em 0;
      @include noselect;
      cursor: pointer;

      .question {
        margin: 0 0 0 0.5em;
        padding: 0;
      }
    }

    .answer {
      max-height: 0;
      overflow-y: hidden;
      color: $color-white;
      transition: all 0.2s ease-in-out;

      p {
        font-size: 0.8em;
      }

      p:first-child {
        margin-top: 0;
        padding-top: 0;
      }
    }

    &[data-open="true"] {
      .answer {
        max-height: 20em;
        color: $color-black;
        overflow-y: auto;
      }
    }
  }

  [dir="rtl"] .faq .faq-header .question {
    margin: 0 0.5em 0 0;
  }
</style>
